// extracted by mini-css-extract-plugin
export var actions = "_s7-4";
export var item = "_s7-1";
export var price = "_s7-3";
export var quantity = "_s7-2";
export var table = "_s7-0";